module.exports = __webpack_public_path__ + "img/m.48b6eedb.jpg";